@if (isNotFound) {
<div class="container text-center">
  <h1 translate>Video room not found</h1>
  @if (!isIFrame && !isAgent) {
  <p translate>
    The call was ended by the agent. Please request for a new video call.
  </p>
  } @if (isIFrame || isAgent) {
  <div class="text-center">
    <p translate>The room was probably closed by another participant.</p>
    <p translate>
      Create a new one by going back and clicking the camera button again.
    </p>
    <a (click)="back()" avButton color="link"
      >&larr; {{ "Back" | translate }}</a
    >
  </div>
  }
</div>
} @if (isScheduleNotFound) {
<div class="container text-center">
  <h1 translate>Video room not found</h1>
  <p translate>Please contact our team to schedule a new video call.</p>
</div>
} @if (isParticipantLimitReached) {
<div class="container text-center">
  <h1 translate>Maximum participants reached</h1>
  <p translate>
    Please notify the agent that provided the link that you cannot join.
  </p>
</div>
} @if (isScheduledLater) {
<div class="container text-center">
  <h1 translate>Video room is not available at this time</h1>
  <p translate>
    This call has been scheduled for a later time. You can join 5 minutes before
    the scheduled start time.
  </p>
</div>
} @if (isNotSupported) {
<div class="container text-center">
  <h1 translate>{{ errorTitle }}</h1>
  <p translate>
    {{ error }}
  </p>
  @if (isMobileChromeRequired) {
  <div>
    <img
      class="browser-icon"
      src="assets/images/chrome-icon.svg"
      alt="Google Chrome"
    />
    <a
      class="btn"
      target="_blank"
      href="https://play.google.com/store/apps/details?id=com.android.chrome"
      >Download</a
    >
  </div>
  } @if (isMobileSafariRequired) {
  <div>
    <img
      class="browser-icon"
      src="assets/images/safari-icon.svg"
      alt="Apple Safari"
    />
  </div>
  } @if (isDesktopChromeRequired) {
  <div>
    <img
      class="browser-icon"
      src="assets/images/chrome-icon.svg"
      alt="Google Chrome"
    />
    <a class="btn" target="_blank" href="https://www.google.com/chrome/"
      >Download</a
    >
  </div>
  }
</div>
} @if (isSessionExpired) {
<div class="container text-center">
  <h1 translate>Session Expired</h1>
  <p translate>Please request a new link from the available agent.</p>
  @if (isAppointmentTokenExpired) {
  <div class="text-muted">
    <p translate>
      You are getting this message because this is not your first time accessing
      this link.
    </p>
    <p translate>
      If the first time you could not join our call, most probably the meeting
      was cancelled and our notification hasn't reached you yet. We are sorry
      for any inconvenience created.
    </p>
  </div>
  }
</div>
} @if (isAccessDenied) {
<div class="container text-center">
  <h1 translate>Access Denied</h1>
  <p translate>Oups! You shouldn't be here.</p>
</div>
} @if (isPageNotFound) {
<div class="container text-center">
  <h2>{{ pageNotFoundMessage }}</h2>
</div>
} @if (isIFrame && isCookiesDisabledError) {
<div class="container text-center">
  <h1 translate>Cookies Disabled</h1>
  <p translate>Please enable third party cookies and try again.</p>
</div>
} @if (!isIFrame && isCookiesDisabledError) {
<div class="container text-center">
  <h1 translate>Cookies Disabled</h1>
  <p translate>Please enable cookies and try again.</p>
</div>
} @if (isPurecloudInitError) {
<div class="container text-center">
  <p translate>Could not initialize application.</p>
</div>
} @if (isGenericError) {
<div class="container text-center">
  <h1 translate>Oups! Something unexpected happened</h1>
  <p>{{ error | translate }}</p>
</div>
} @if (isAuthenticationError) {
<div class="container text-center">
  <h1 translate>Authentication failed</h1>
  <p translate>{{ error }}</p>
</div>
} @if (isRTCConnectionError) {
<div class="container text-center">
  @if (isMobileSafari26) {
  <h1 translate>Connection failed</h1>
  <p translate>
    Safari 26 isn't currently supported. Please switch to a supported browser
    like Chrome or Firefox.
  </p>
  } @if (!isMobileSafari26) {
  <h1 translate>Connection to RTC failed</h1>
  <p translate>
    Please make sure you have opened all the required ports and that the service
    is up and running
  </p>
  }
</div>
} @if (isAppointmentCompleted) {
<div class="container text-center">
  <h1 translate>Appointment has been completed</h1>
  <p translate>Please request a new appointment</p>
</div>
} @if (isAppointmentExpired) {
<div class="container text-center">
  <h1 translate>Appointment has expired</h1>
  <p translate>Please request a new appointment</p>
</div>
} @if (isAppointmentError) {
<div class="container text-center">
  <h1 translate>We were unable to start your appointment at this time.</h1>
  <p class="text-muted" translate>
    {{ error }}
  </p>
</div>
} @if (isAppointmentRevoked) {
<div class="container text-center">
  <h1 translate>Invalid link</h1>
  <p translate>
    This link is no longer valid. If you believe this is an error, please
    contact the issuer of the link or the relevant support team.
  </p>
</div>
} @if (isLicenseRequired) {
<div class="container text-center">
  <h1 translate>License required</h1>
  <p translate>You don't have the proper license to access this page</p>
  <p translate class="text-center">
    <a (click)="back()" avButton color="link"
      >&larr; {{ "Back" | translate }}</a
    >
  </p>
</div>
} @if (isAppointmentNotFound) {
<div class="container text-center">
  <h1 translate>Appointment not found</h1>
  <p translate>Please request a new appointment</p>
</div>
} @if (isConversationFailed) {
<div class="container text-center">
  <h1 translate>Could not estabish a connection</h1>
  <p translate>Please follow the appointment link to try again</p>
</div>
} @if (isTicketNotFound) {
<div class="container text-center">
  <h1 translate>Ticket has expired or is invalid</h1>
  <p translate>Please request a new one</p>
</div>
} @if (!!redirectUrl) {
<div class="copy-container">
  <h2 class="copy-container-title" translate>Room Link</h2>
  <div class="textarea-wrapper">
    <div class="textarea-container">
      <textarea rows="2" disabled>{{ redirectUrl }}</textarea>
    </div>
    <div>
      <button avButton color="accent" (click)="copy()" translate>
        Copy to clipboard
      </button>
    </div>
  </div>
</div>
}

<!-- <av-card
        class="appointment"
        *ngIf="isAppointmentAvailable()"
        [backdrop]="false"
        >
        <av-card-header>
          {{ "Appointment" | translate }}
        </av-card-header>
        <av-card-body [no-header]>
          <div class="fx-row fx-gap fx-align-center">
            <h3 class="no-margin">
              {{
              appointment().start
              | dayjsFormat : "dddd DD MMMM, HH:mm" : lang
              }}
            </h3>
            <span class="text-muted">{{ timezoneOffset() }}</span>
          </div>
        </av-card-body>
      </av-card> -->
